import { render, staticRenderFns } from "./FormControlStockQuantity.vue?vue&type=template&id=10c55edc"
import script from "./FormControlStockQuantity.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlStockQuantity.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports